import React, { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import api, { formatMoney, formatNumber, formatPct } from "../lib/api";
import { CompradoSinVentaPanel } from "./CompradoSinVentaPanel";

export function KpiCompradoSinVenta() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/inventory/bought-last-month").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return <div className="card kpi-card" data-testid="kpi-comprado-sin-venta"><div className="kpi-label">Comprado último mes sin ventas</div><div className="kpi-value">—</div></div>;
  const alto = d.ratio > 0.3;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="kpi-comprado-sin-venta"
              className="card kpi-card text-left hover:shadow-md hover:border-amber-300 hover:-translate-y-0.5 transition cursor-pointer"
              title={`Entradas del ${new Date(d.desde).toLocaleDateString("es-ES")} al ${new Date(d.hasta).toLocaleDateString("es-ES")} que todavía no se han vendido (a PVP)`}>
        <div className="flex items-center justify-between">
          <div className="kpi-label">Comprado último mes sin ventas</div>
          <ShoppingCart size={16} className="text-amber-500" />
        </div>
        <div className={"kpi-value " + (alto ? "text-amber-600" : "")} data-testid="kpi-comprado-sin-venta-ratio">{formatPct(d.ratio)}</div>
        <div className="kpi-sub" data-testid="kpi-comprado-sin-venta-eur">
          {formatMoney(d.sin_venta_eur)} de {formatMoney(d.comprado_eur)} comprados · {formatNumber(d.sin_venta_refs)} refs.
        </div>
        <div className="text-[10px] uppercase tracking-widest text-amber-700 font-semibold mt-2">{formatPct(d.pct_stock_total)} del stock total · Ver lista →</div>
      </button>
      <CompradoSinVentaPanel open={open} onOpenChange={setOpen} />
    </>
  );
}
